import {
  ActionIcon,
  Box,
  Button,
  Drawer,
  Grid,
  Group,
  Modal,
  MultiSelect,
  Paper,
  Popover,
  ScrollArea,
  Select,
  Skeleton,
  Stack,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { logger } from "utils/logger";
import { useForm } from "@mantine/form";

import { Crumbline, FormInputWrapper } from "../../../../core/components";

import { SampleStatusTypes } from "core/models/SampleModel";
import { useAbortController } from "core/hooks/useAbortableController";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
import {
  IconAdjustmentsHorizontal,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
} from "@tabler/icons-react";
import { isDate } from "moment";
import CustomDatePicker from "core/components/datePicker/CustomDatePicker";
import StyleMediaList from "./StyleMediaList";
import {
  fetchStyle,
  getStyleSuccess,
} from "modules/Distributions/distributionSlice";
// import StyleAssetViewer from "./StyleAssetViewer";
import { CaptureEventType } from "core/components/capture/CaptureThumb";
import { AppConstants } from "utils/constants";
import { useDisclosure, useLocalStorage } from "@mantine/hooks";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import InfoPanel from "../distributions/InfoPanel";
import StyleAssetViewer from "core/components/styleInfoPanel/StyleAssetViewer";
import { getClientLabel } from "utils/helper";

const Style = ({
  user,
  style,
  styleMediaFilter,
  setStyleFilter,
  success,
  error,
}) => {
  const dispatch = useDispatch();
  // const { classes } = useStyles();
  const [listView, setListView] = useState(ListViewOption.LIST);
  const params = useParams();
  const [activeTab, setActiveTab] = useState("styles");
  const navigate = useNavigate();
  const lastFetchedId = useRef(null);
  const abortController = useAbortController();
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [wipData, setWipData] = useState([]);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const [displaySettings, setDisplaySettings] = useLocalStorage({
    key: "op-style-display-settings",
    defaultValue: {
      imageFit: "cover",
      showMeta: true,
      imageSize: "300",
    },
  });

  useEffect(() => {
    logger.log(success);
    if (success) {
      switch (success.type) {
        case getStyleSuccess.toString(): {
          setIsLoading(false);
          break;
        }
      }
    }
  }, [success]);

  // get the style from the url
  useEffect(() => {
    if (
      params &&
      params.id &&
      params.id !== lastFetchedId.current &&
      (!style || style.styleNumber !== params.id)
    ) {
      setIsLoading(true);
      dispatch(fetchStyle(params.id));
      lastFetchedId.current = params.id;
      // fetch the styles
      // dispatch(fetchSeasonStyles(params.id))
    } else {
      if(style && style.styleNumber === params.id) {
        setIsLoading(false);
      }
      // setIsLoading(false);
    }
  }, [params, params.id, style, dispatch]);

  const form = useForm({
    initialValues: {
      ...style,
      name: "",
      deadline: new Date(2021, 11, 5),
    },

    validate: {
      // email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
    },
  });

  useEffect(() => {
    const deadline = style && style.deadline ? new Date(style.deadline) : "";
    form.setValues({ ...style, deadline: deadline });
  }, [style]);

  const onFormSubmit = (vals) => {
    logger.log("Submitting form");
    const data = {
      id: style.id,
      code: form.values.code,
      name: form.values.name,
      description: form.values.description,
      deadline: form.values.deadline,
      tags: form.values.tags.join(","),
      // team:form.values.team,
      // ts:form.values.ts,
    };
    // dispatch(updateSeason(data, user));
  };

  const crumbItems = [
    { title: "Distributions", route: "/distributions", search: "" },
    { title: style?.styleNumber, route: `distributions/${style?.styleNumber}` },
  ];

  /**
   * Effect to handle location change
   */

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");
    logger.log(
      "location change ",
      location,
      " DISPLAY: ",
      displayType,
      params,
      listView
    );
    // if display type changes
    if (displayType && displayType !== listView) setListView(displayType);
  }, [location]);

  const onStatusClick = (type, data) => {
    switch (type) {
      // if they have clicked on the photography count then we want to filter
      // the media based on the style code
      // case SampleStatusTypes.SAMPLE_PHOTOGRAPHY_COUNT:{
      //     const filter = {...mediaFilter,styles:[data.stylenumber]};
      //     setMediaFilter(filter);

      //     // nav to the media tab
      //     onTabChange('media');
      //     break;
      // }
      // case SampleStatusTypes.SAMPLE_TASK_COUNT:{
      //     const filter = {...taskFilter,styles:[data.stylenumber]};
      //     setTaskFilter(filter);

      //     // nav to the media tab
      //     onTabChange('tasks');
      //     break;
      // }
      case SampleStatusTypes.SAMPLE_SCAN_COUNT: {
        // take them too the scan
        navigate(`/warehouse/scans/${data.scan.gid}`);
        logger.log(data);
        break;
      }
      default: {
        break;
      }
    }
  };

  const setFilterVars = (vals) => {
    logger.log(vals);
    // setStyleFilter(vals);
  };
  const filterWips = useCallback(() => {
    // var data = filterSamples(wips, styleMediaFilter);
    // setWipData(data);
  }, [
    styleMediaFilter.brands,
    styleMediaFilter.categories,
    setWipData,
    styleMediaFilter.groupBy,
    styleMediaFilter.keyword,
  ]);

  useEffect(() => {
    // filter the data.
    filterWips();
  }, [filterWips]);

  logger.log(style);

  const getFilterCount = (val) => {
    var count = 0;

    const dateKeys = ["otbDate", "distribution", "completed"];
    const ignoreKeys = ["groupBy"];

    Object.entries(val).forEach(([key, value]) => {
      if (value && value.length && ignoreKeys.indexOf(key) === -1) {
        ++count;
      }

      if (key === "status") {
        var statusCount = 0;
        Object.entries(value).forEach(([key, value]) => {
          if (value.length) {
            statusCount = 1;
          }
        });

        count += statusCount;
      }

      if (dateKeys.indexOf(key) > -1) {
        if (isDate(value.dateStart) || isDate(value.dateEnd)) {
          ++count;
        }
      }
    });

    return count;
  };

  useEffect(() => {
    const count = getFilterCount(styleMediaFilter);
    setFilterCount(count);
  }, [styleMediaFilter]);

  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();

    // setWipFilter({ ...new SampleFilterModel({ groupBy: styleMediaFilter.groupBy }) });

    logger.log("CLEAR CLICK", e);
  };

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    navigate({ search: `?displayType=${val}` });
  };

  const filterButtonHandler = (e) => {
    logger.log("BUTTON CLICK", e, e.nativeEvent);
    setFilterOpen((o) => !o);
  };

  const onMediaAction = (e, val, items) => {
    logger.log(e);
    switch (e) {
      case CaptureEventType.IMAGE_CLICK: {
        setSelectedAsset(val);
        setImageModalOpen(true);
        break;
      }
      default: {
        break;
      }
    }
    logger.log(e, val, items);
  };

  const onChange = (vals) => {
    setDisplaySettings(vals);
  };

  const [opened, { open, close, toggle }] = useDisclosure(false);
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Group className="main-container-header">
        <Group position="apart" sx={{ width: "100%" }}>
          <Crumbline items={crumbItems}></Crumbline>
          {/* <Button>Update Season</Button> */}
        </Group>
      </Group>
      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Group style={{ width: "100%" }} justify="space-between">
          <Group>
            {isLoading ? (
              <Group>
                <Skeleton height={30} width={300} />
                <Skeleton height={30} width={50} />
              </Group>
            ) : (
              <Group>
                <Title order={3} lh={"lg"}>
                  {style?.name}
                </Title>
                {style ? <PrimaryBadge>{style?.dept}</PrimaryBadge> : null}
              </Group>
            )}
          </Group>

          <Group>
          <Popover width={300} position="bottom" withArrow shadow="md">
            <Popover.Target>
              <Button
                leftSection={
                  <IconAdjustmentsHorizontal
                    size={AppConstants.ICON_SIZE}
                    stroke={AppConstants.ICON_STROKE_WIDTH}
                  />
                }
                variant="default"
              >
                Display Settings
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Paper p="md" radius="sm">
                <Stack spacing="md">
                  <Select
                    label="Image Fit"
                    description="How the image should fit within its container"
                    data={imageFitOptions}
                    value={displaySettings.imageFit}
                    comboboxProps={{ withinPortal: false }}
                    onChange={(value) =>
                      onChange({ ...displaySettings, imageFit: value })
                    }
                  />

                  <Select
                    label="Size"
                    description="How the image should fit within its container"
                    data={imageSizeOptions}
                    value={displaySettings.imageSize}
                    comboboxProps={{ withinPortal: false }}
                    onChange={(value) =>
                      onChange({ ...displaySettings, imageSize: value })
                    }
                  />

                  <Switch
                    label="Show Meta Information"
                    description="Display additional image metadata"
                    checked={displaySettings.showMeta}
                    onChange={(event) =>
                      onChange({
                        ...displaySettings,
                        showMeta: event.currentTarget.checked,
                      })
                    }
                  />
                </Stack>
              </Paper>
            </Popover.Dropdown>
          </Popover>

          <Tooltip
            position="bottom"
            label={opened ? "Hide Info Panel" : "Show Info Panel"}
          >
            <ActionIcon
              
              variant="default"
              onClick={() => toggle()}
              size={"lg"}
            >
              {opened ? (
                <IconLayoutSidebarRightCollapse size={18} />
              ) : (
                <IconLayoutSidebarRightExpand size={18} />
              )}
            </ActionIcon>
          </Tooltip>
          </Group>
        </Group>
        {/* <ListToggleControl
          value={listView}
          onChange={(val) => listToggleHandler(val)}
        /> */}
      </Group>
      <Group
        className="container-action-bar"
        style={{ width: "100%" }}
        justify="space-between"
        height={"100%"}
        py="xs"
      >
        <Text order={6} size="sm" my={"xs"}>
          Displaying {style?.assets?.length} Assets
        </Text>
        {/* <Group>
          <CheckboxDropdown selectedItems={selectedWips} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} />
          <Input
            leftSection={<IconSearch />}
            style={{ width: 250 }}
            value={styleMediaFilter.keyword}
            onChange={(e) =>
              setStyleFilter({
                ...styleMediaFilter,
                keyword: e.currentTarget.value,
              })
            }
            // placeholder="Filter assets"
            placeholder={`Search across ${wips.length} ${pluralize('Record',wips.length)}`}
            rightSectionPointerEvents="all"
            rightSection={
              <ActionIcon
                variant="transparent"
                onClick={() =>
                  setStyleFilter({
                    ...styleMediaFilter,
                    keyword: "",
                  })
                }
              >
                {styleMediaFilter.keyword.length ? <IconX size={14} /> : null}
              </ActionIcon>
            }
          />
        </Group>
        <Group>
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={610}
            withArrow
            closeOnClickOutside={true}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div wip={{ display: "flex" }}>
                <FilterPanel
                  filter={styleMediaFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                  user={user}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
          {listView !== ListViewOption.CALENDAR ? (
            <Select
              placeholder="Group By"
              value={styleMediaFilter.groupBy}
              onChange={(val) =>
                setStyleFilter({ ...styleMediaFilter, groupBy: val })
              }
              data={[
                { value: "", label: "No Group" },
                { value: "seasonCode", label: "Group by Season" },
                { value: "sessionCode", label: "Group by Session" },
                { value: "dept", label: "Group by Department" },
                { value: "status", label: "Group by Status" },
              ]}
            />
          ) : null}
        </Group> */}
      </Group>

      {/* <Group pt={"lg"} position="apart">
        <Title order={3}>{season?.name}</Title>
        <Group>
          <Menu width={200} shadow="md">
            <Menu.Target>
              <Button>Upload Spreadsheet</Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item onClick={() => onUploadClick("seasons")}>
                Upload Event Styles
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
         
        </Group>
      </Group> */}
      <Grid
        // mb="lg"
        style={{
          margin: 0,
          height: "100%",
          flexGrow: 1,
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        <Grid.Col h={"100%"} span={12}>
          <div style={{ height: "100%", flex: 1 }}>
            <div style={{ height: "100%" }}>
              <StyleMediaList
                onMediaAction={onMediaAction}
                displaySettings={displaySettings}
              />
            </div>
          </div>
        </Grid.Col>

        {/* <Grid.Col></Grid.Col> */}
      </Grid>

      <Drawer
        id="drawer"
        opened={opened}
        closeOnEscape={false}
        trapFocus={true}
        onClose={() => {
          let urlParms = Object.fromEntries([...searchParams]);
          delete urlParms.styleNumber;
          setSearchParams(urlParms);
          close();
        }}
        title="Style Information"
        position="right"
      >
        {/* Drawer content */}
        <InfoPanel selectedItem={style} opened={opened} user={user} />
      </Drawer>

      <Modal
        opened={imageModalOpen}
        p={0}
        // title={selectedItem.name}
        trapFocus={true}
        closeOnEscape={true}
        id="captureModal"
        withCloseButton={false}
        fullScreen
        onClose={() => setImageModalOpen(false)}
        styles={{
          content: { padding: 0, height: "100vh" },
        }}
      >
        {/* <CaptureDetail
          showSettings={false}
          resoloveImage={false}
          image={selectedAsset}
          src={selectedAsset?.preview}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={() => {}}
        /> */}

        <StyleAssetViewer
          user={user}
          style={style}
          index={style?.assets?.findIndex (
            (val) => val.assignedSequence === selectedAsset?.assignedSequence
          )}
          onClose={() => setImageModalOpen(false)}
        />
      </Modal>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    styleMediaFilter: state.distributionReducer.styleMediaFilter,
    style: state.distributionReducer.selectedStyle,
    assets: state.distributionReducer.assets,
    // season: state.seasonReducer.selectedSeason,
    success: state.distributionReducer.success,
    // error: state.seasonReducer.error,
  };
};

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(Style);

const FilterPanel = ({ onCancel, onApply, filter, filterItems, user }) => {
  const form = useForm({
    initialValues: {
      ...filter,
      // status:{
      //     sampleCount:filter.status.sampleCount.toString(),
      //     photographyCount:filter.status.photographyCount.toString(),
      //     taskCount:filter.status.taskCount.toString(),
      //     taskCompletedCount:filter.status.taskCompletedCount.toString()
      // }
    },
  });

  useEffect(() => {
    if (filter && form) {
      form.setValues({ ...filter });
    }
  }, [filter]);

  const getFilterVars = useCallback(
    (key) => {
      var res = [];
      if (filterItems[key])
        Object.keys(filterItems[key]).forEach((val) => res.push(val));
      return res.sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true })
      );
    },
    [filter, filterItems]
  );

  return (
    <Box shadow="xs" wip={{ width: "100%" }}>
      <form onSubmit={form.onSubmit((values) => onApply(values))}>
        <ScrollArea h={400} wip={{ overflowX: "hidden" }}>
          <Box>
            <FormInputWrapper label="Wip" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("wipsCodes")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("wipsCodes")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Department" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("depts")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("departments")}
              />
            </FormInputWrapper>

            <FormInputWrapper
              label="Status"
              id="input-status"
              labelWidth={"120px"}
            >
              <MultiSelect
                data={getFilterVars("statuses")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("statuses")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Events" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("seasons")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("seasons")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Sessions" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("sessions")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("sessions")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Issuers" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("issuers")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("issuers")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Talent" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("talents")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("talents")}
              />
            </FormInputWrapper>

            <FormInputWrapper
              label={getClientLabel(user.clientCode, 'otbDate')}
              id="input-otbDate"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder={`From ${getClientLabel(user.clientCode, 'otbDate')}`}
                  {...form.getInputProps("otbDate.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder={`To ${getClientLabel(user.clientCode, 'otbDate')}`}
                  {...form.getInputProps("otbDate.dateEnd")}
                />
              </Group>
            </FormInputWrapper>

            <FormInputWrapper
              label="Completed Date"
              id="input-completed"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="From Completed Date"
                  {...form.getInputProps("completed.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="To Completed Date"
                  {...form.getInputProps("completed.dateEnd")}
                />
              </Group>
            </FormInputWrapper>

            <FormInputWrapper
              label="Distribution Date"
              id="input-completed"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="From Distribution Date"
                  {...form.getInputProps("distribution.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="To Distribution Date"
                  {...form.getInputProps("distribution.dateEnd")}
                />
              </Group>
            </FormInputWrapper>
          </Box>
        </ScrollArea>

        <Group justify="space-between" mt="lg">
          <Button
            variant="subtle"
            component="button"
            size="sm"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button type="submit" size="sm">
            Apply
          </Button>
        </Group>
      </form>
    </Box>
  );
};

const imageFitOptions = [
  { value: "cover", label: "Cover" },
  { value: "contain", label: "Contain" },
];

const imageSizeOptions = [
  { value: "150", label: "Small" },
  { value: "300", label: "Medium" },
  { value: "400", label: "Large" },
  { value: "600", label: "XLarge" },
];
